import { Component, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { ApiService } from 'src/app/providers/api.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { SubscriptionComponent } from '../subscription/subscription.component';
import { Subscription } from 'rxjs';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'sm-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  problemData:any=[false,false,false,false,false];
  name: string = ''
  phone:any = ''
  subject: string = ''
  message: string = ''
  email: string = ''
  _apiSubscription: Subscription= new Subscription()
  constructor(private _navService: NavigationService, private _apiService: ApiService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging, private loaderservice: LoaderServiceService) { 
    this._navService.hideSidebarAndNav = false;
    this._apiSubscription = this._apiService.apiResult.subscribe(resData => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_CONTACT_US) {
        console.log(resData);
         if(resData.result){
          this.name = this.phone = this.subject = this.message = this.email = ''
          this.problemData = [false,false,false,false,false];
          sessionStorage.setItem("isContactUsSentBusiness","true")
          this.contactUsFlag = true
          this.loaderservice.showLoader = false

         }
      }
    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
  }
  contactUsFlag: boolean = false
  ngOnInit(): void {
    this.phone = localStorage.getItem(SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER)
    this.name = localStorage.getItem(SM_CONSTANTS.OWNER_NAME)!
    if(sessionStorage.getItem("isContactUsSentBusiness") && sessionStorage.getItem("isContactUsSentBusiness") != 'null' && sessionStorage.getItem("isContactUsSentBusiness") == "true"){
      this.contactUsFlag = true
    }
    
  }

  clickChip(index:any){
    this.problemData[index] = !this.problemData[index]
  }

  checkForm(){
    const index = this.problemData.findIndex((item:any) => item == true)
    if(index == -1){
      return true
    }
    else{
      return false
    }
  }

  sendContactUs(){
    let errorData:any='';
    if(this.problemData[0]){
      errorData += 'Issue/Bug Reporting' + ',';
    }
    if(this.problemData[1]){
      errorData += 'Feature Request' + ',';
    }
    if(this.problemData[2]){
      errorData += 'Feedback' + ',';
    }
    if(this.problemData[3]){
     errorData += 'Testimonials' + ',';
    }
    if(this.problemData[4]){
      errorData += 'Others' + ',';
    }

    let contactDetail = {
      contactUsInfo : {
        name : this.name,
        email : this.email,
        subject : this.subject,
        message : this.message,
        phone: this.phone,
        type : (errorData) ? errorData : 'query'
      }

    }

    console.log(contactDetail);
    this.loaderservice.showLoader = true
    this._apiService.contactUs(contactDetail)


  }


  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE)
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

}



